import { c } from '../../../utils/tailwind-merge';
import Button from '../../atoms/Button';
import { ReviewBars } from '../../molecules/ReviewBars';
import { ReviewStars } from '../../molecules/ReviewStars';
import { WriteReviewModal } from '../WriteReviewModal';
import { ProductRatingProps } from './ProductRating.types';

export const ProductRating = ({
  reviewStars,
  canWriteReview,
  writeReviewModal,
  ownedDate,
  microcopy,
  onFilterReviews,
  onSubmitReview,
  onEmailPublisher,
  reviewList,
  className,
}: ProductRatingProps) => {
  return (
    <section className={c(className)}>
      <p className="text-md font-medium tracking-[-0.108px] text-grey-900">
        {microcopy.overall}
      </p>
      <div className="my-8 flex flex-col md:my-6 md:flex-row">
        <ReviewStars
          value={reviewStars.value}
          max={reviewStars.max}
          reviews={reviewStars.reviews}
          microcopy={{
            reviews: microcopy.reviews,
            ariaLabel: microcopy.ariaLabel,
          }}
          variant={'large'}
        />
        <div className="mt-8 flex w-full justify-center md:mt-0">
          <ReviewBars
            microcopy={{
              rating: microcopy.reviewBars.rating,
              ratings: microcopy.reviewBars.ratings,
              ratingAriaLabel: microcopy.reviewBars.ratingAriaLabel,
              ariaLabel: microcopy.reviewBars.ariaLabel,
            }}
            reviewList={reviewList}
            className="w-80 md:w-[396px]"
            onFilterReviews={onFilterReviews}
          />
        </div>
      </div>
      {canWriteReview && ownedDate && (
        <WriteReviewModal
          title={writeReviewModal.title}
          imageUrl={writeReviewModal.imageUrl}
          version={writeReviewModal.version}
          ownedDate={writeReviewModal.ownedDate}
          microcopy={microcopy.writeReviewModal}
          onEmailPublisher={onEmailPublisher}
          onSubmitReview={onSubmitReview}
          reviewModalTrigger={
            <Button.v2
              label={microcopy.writeReviewModal.title}
              shape="square"
              size="small"
              className="w-full px-5 md:w-auto"
              data-testid="write-review-button"
              name={microcopy.writeReviewModal.title}
              role="button"
            />
          }
          className="mb-0 w-full md:mb-8 md:w-auto"
        />
      )}
    </section>
  );
};
